import React from 'react'
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import {useSelector} from 'react-redux' 
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { Baseurl } from '../../constants/env';


const Modals = (props) => {
    const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const{enqueueSnackbar} = useSnackbar();
const {userid} = useSelector((state)=>state.auth) 
  async function removeItem(id){
    
    
 await  axios(`${Baseurl}/cart/${id}?name=${userid}`,{ withCredentials: true })
 .then((resp) => {
  //console.log(resp);
  props.setremove(resp);
  setShow(false);
  enqueueSnackbar('A Product Removed From Cart',{variant:'success'});
   
 }).catch((e)=>{
   console.log(e.mesaage);
 });
 }
  return (
    <>
    <button onClick={handleShow} className='text-white' >
      Remove
    </button>

    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false} style={{marginTop:'150px'}}
    >
      <Modal.Header closeButton className='bg-info'>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center bg-info text-white'>
       Are You Sure ? 
      </Modal.Body>
      <Modal.Footer className='bg-info'>
        <button onClick={handleClose}>
          No
        </button>
        <button style={{ backgroundColor: 'lightred'}} onClick={()=>{removeItem(props.itemid)}}>Yes</button>
      </Modal.Footer>
    </Modal>
  </>
  )
}

export default Modals
